module.exports = __webpack_public_path__ + "10f53e99428a1745f852cdd16ac4402f.pdf";